export const getMiliseconds = (props) => {
  const { startHours, startMinutes, startSeconds } = props;
  const hasStartTime = (startHours || startMinutes || startSeconds) ?  true : false ;

  if(hasStartTime) {
    const secondsMili = startSeconds ? startSeconds * 1000 : 0 ;
    const minutesMili = startMinutes ? startMinutes * 1000 * 60 : 0 ;
    const hoursMili = startHours ? startHours * 1000 * 3600 : 0 ;

    return secondsMili + minutesMili + hoursMili;
  }
  return 0;
}

export const getSeconds = (props) => {
  const { startHours, startMinutes, startSeconds } = props;
  const hasStartTime = (startHours || startMinutes || startSeconds) ?  true : false ;

  if(hasStartTime) {
    const seconds = startSeconds ? startSeconds : 0 ;
    const minutes = startMinutes ? startMinutes * 60 : 0 ;
    const hours = startHours ? startHours * 3600 : 0 ;

    return seconds + minutes + hours;
  }
  return 0;
}

export const getSecondsFromTimelineLabel = (time) => { // Format: "3:37"
  if(!time) { return 0; }

  let t = time.split(':').reverse();

  const seconds = t[0] ? t[0] : 0;
  const minutes = t[1] ? t[1] * 60 : 0;
  const hours = t[2] ? t[2] * 3600 : 0;

  return parseInt(seconds) + parseInt(minutes) + parseInt(hours);
}

export const getMilisecondsFromTimelineLabel = (time) => { // Format: "3:37"
  if(!time) { return 0; }

  let t = time.split(':').reverse();

  const secondsMili = t[0] ? t[0] * 1000 : 0;
  const minutesMili = t[1] ? t[1] * 60 * 1000 : 0;
  const hoursMili = t[2] ? t[2] * 3600 * 1000 : 0;
  
  return parseInt(secondsMili) + parseInt(minutesMili) + parseInt(hoursMili);
}

export const youtubeParser = (url) => { // Returns the ID from a URL
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}
